export default class Utils {
    public static hourToMs(hour:number):number {
        return (hour * 60 * 60) * 1000;
    }

    public static mapToChartData(data:any){
        let result = data.map((obj: any) => {
            let rObj: { x: number; y: number } = {
                x: obj.property,
                y: obj.value
            };
            return rObj;
        });

        return result;
    }


    public static convertToReaderFriendlyDate(date:string){
        // let test = date.toISOString().split('T')[0];
        let newDate = new Date(date);
        let newDate2 = new Date(newDate);

        return `${newDate.toISOString().split('T')[0]} ${prependZero(newDate.getHours())}:${prependZero(newDate.getMinutes())}`;
        //return ""// `${new Date(date).toISOString().split('T')[0]}`;
    }

    public static resizeImage = (settings: ResizeImageOptions) => {
        const file: File = settings.file;
        const maxSize: number = settings.maxSize;
        const reader = new FileReader();
        const image = new Image();
        const canvas = document.createElement("canvas");
        const dataURItoBlob = (dataURI: string) => {
            const bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ?
                atob(dataURI.split(",")[1]) :
                unescape(dataURI.split(",")[1]);
            const mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            const max = bytes.length;
            const ia = new Uint8Array(max);
            for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
        };
        const resize = () => {
            let width = image.width;
            let height = image.height;

            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }

            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d")!.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL("image/jpeg");
            return dataURItoBlob(dataUrl);
        };

        return new Promise((ok, no) => {
            if (!file.type.match(/image.*/)) {
                no(new Error("Not an image"));
                return;
            }

            reader.onload = (readerEvent: any) => {
                image.onload = () => ok(resize());
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
            // return file.type;
        });

    }


}

function prependZero(num:number){
    return num >= 10 ? num.toString() : "0" + num.toString();

}

export interface ResizeImageOptions {
    maxSize: number;
    file: File;
}